import { FC } from 'react';

const Header: FC = () => (
  <h2 className="text-2xl font-semibold bg-base-white">Contact card</h2>
);

export default Header;
